import { useEffect, useState } from 'react';

import SearchFilterView from './SearchFilterView';

interface IProps {
  onChangeFilter?: (name: string, value: number | string) => void;
  filter: Record<string, any>;
  value: string;
  placeholder?: string;
}

const SearchFilter = ({ onChangeFilter, filter, value, placeholder }: IProps) => {
  const [searchText, setSearchText] = useState(value || '');
  const [isSubmitted, setIsSubmmited] = useState(!!value);

  useEffect(() => {
    setSearchText(value);
  }, [value]);

  const handleChangeFilter = (value) => {
    if (isSubmitted) {
      onChangeFilter(filter.name, '');
      setSearchText('');
      setIsSubmmited(false);

      return;
    }

    onChangeFilter(filter.name, value);
    setIsSubmmited(true);
  };

  const onChange = (value) => {
    setSearchText(value);
    setIsSubmmited(false);
  };

  return (
    <SearchFilterView
      {...{
        handleChangeFilter,
        filter,
        value,
        searchText,
        onChange,
        isSubmitted,
        placeholder,
      }}
    />
  );
};

export default SearchFilter;
